import React, { useEffect, useRef } from 'react';

import * as Styled from './ChapterLabel.styles';

export interface ChapterLabelProps {
  title: string;
  description?: string;
  accessibilityLabel?: string;
  isFocusable?: boolean;
  as?: any;
}

const defaultProps: Partial<ChapterLabelProps> = {
  title: '',
  accessibilityLabel: '',
  description: null,
  isFocusable: false,
  as: 'h4',
};

const ChapterLabel: React.FC<ChapterLabelProps> = ({
  title,
  description,
  accessibilityLabel,
  isFocusable,
  as,
}) => {
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (titleRef?.current && isFocusable) {
      setTimeout(() => {
        titleRef?.current?.focus();
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleRef]);

  return (
    <Styled.Container>
      <Styled.Title
        dangerouslySetInnerHTML={{ __html: title }}
        aria-label={accessibilityLabel ? accessibilityLabel : ''}
        ref={isFocusable ? titleRef : null}
        as={as}
      ></Styled.Title>
      {description && <p dangerouslySetInnerHTML={{ __html: description }}></p>}
    </Styled.Container>
  );
};

ChapterLabel.defaultProps = defaultProps;

export default ChapterLabel;
